import {portalApiPost,PortalApiError} from '@/lib/portal-api';
import {moneyOperationSession} from './money-operation-session';
import {draftStorageKey,type MoneyDrawerEntryWire} from './money-desk-view';
export interface PendingDrawer {path:string;body:Record<string,unknown>;requestId:string}
const event='money-drawer-recovery';
function read(key:string):PendingDrawer|null {
 const raw=sessionStorage.getItem(key);if(!raw)return null;
 const x=JSON.parse(raw) as PendingDrawer;
 if(!x || !/^\/accounts\/entries(?:\/[1-9]\d*\/(?:reverse|proof))?$/.test(x.path)||!x.body||!Number.isSafeInteger(x.body.clinicId)||typeof x.requestId!=='string')throw new Error('The saved drawer action could not be read. Keep this session for recovery.');
 return x;
}
function changed(){window.dispatchEvent(new Event(event));}
export function onDrawerRecoveryChange(fn:()=>void){window.addEventListener(event,fn);return()=>window.removeEventListener(event,fn);}
export async function pendingDrawer(){const s=await moneyOperationSession('drawer');const pending=read(s.key);await s.assertCurrent();return pending;}
export async function postDrawer<T extends {entry:MoneyDrawerEntryWire}>(path:string,payload:Record<string,unknown>):Promise<T> {
 const s=await moneyOperationSession('drawer');const body={...payload};delete body.requestId;
 let pending=read(s.key);
 if(pending&&(pending.path!==path||JSON.stringify(pending.body)!==JSON.stringify(body)))throw new Error('Recover the saved drawer action before making another change.');
 if(!pending){pending={path,body,requestId:typeof payload.requestId==='string'?payload.requestId:crypto.randomUUID()};sessionStorage.setItem(s.key,JSON.stringify(pending));if(JSON.stringify(read(s.key))!==JSON.stringify(pending))throw new Error('Recovery could not be saved. Nothing was sent.');changed();}
 await s.assertCurrent();
 try {
  const result=await portalApiPost<T>(pending.path,{...pending.body,requestId:pending.requestId},s.bearer);
  await s.assertCurrent();
  if(!result?.entry||!Number.isSafeInteger(result.entry.id)||result.entry.clinicId!==pending.body.clinicId||
   (path==='/accounts/entries'&&(result.entry.kind!==pending.body.kind||result.entry.amountMinorUnits!==pending.body.amountMinorUnits))||
   (path.endsWith('/proof')&&(result.entry.id!==Number(path.split('/')[3])||!result.entry.proofImageId))||
   (path.endsWith('/reverse')&&result.entry.reversesEntryId!==Number(path.split('/')[3])))throw new Error('The drawer action could not be confirmed. Recover the saved request.');
  if(path==='/accounts/entries'&&pending.body.kind!=='bank_deposit'&&typeof pending.body.businessDate==='string') {
    const draftSession=await moneyOperationSession('draft');await s.assertCurrent();
    sessionStorage.removeItem(draftSession.key+':'+draftStorageKey(Number(pending.body.clinicId),pending.body.businessDate,pending.body.kind as 'spent'|'petty_cash'));
    sessionStorage.removeItem(draftSession.key+':'+draftStorageKey(Number(pending.body.clinicId),pending.body.businessDate));
  }
  sessionStorage.removeItem(s.key);changed();return result;
 }catch(e){
  if(e instanceof PortalApiError&&['VALIDATION_FAILED','drawer_unavailable','day_already_closed','entry_already_reversed','proof_already_attached'].includes(e.code??'')){sessionStorage.removeItem(s.key);changed();}
  throw e;
 }
}
export async function recoverDrawer(clinicId:number){
 const p=await pendingDrawer();if(!p)return null;
 if(p.body.clinicId!==clinicId)throw new Error('Open the original branch to recover this action.');
 return postDrawer(p.path,{...p.body,requestId:p.requestId});
}
